export const SET_USER_CLICK_TYPE = 'SET_USER_CLICK_TYPE'
